<div [class]="loaderClass">
  <div>
    <div class="loader"></div>
    <h3>{{ 'loading' | translate }}</h3>
  </div>
</div>
